import { useState } from "react";
import { ChevronDown, MapPin, Search } from "lucide-react";
import { useLang } from "../../lib/LangContext";
import { p22Copy } from "../../lib/p22Copy";
import { filterEntries, selectCity } from "../../lib/serviceAreas";
import { scrollToSection } from "../../lib/scroll";

// Expandable, searchable list of every service location; click preselects the city in the booking wizard.
export const FooterCities = () => {
  const { lang } = useLang();
  const a = p22Copy(lang).area;
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const list = filterEntries(q);
  const pick = (label) => {
    selectCity(label);
    if (document.getElementById("contact")) scrollToSection("contact", { flow: "price" });
  };
  return (
    <div data-testid="footer-cities" className="pb-10">
      <button type="button" aria-expanded={open} data-testid="footer-cities-toggle" onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-2 text-[12px] tracking-[0.25em] uppercase text-zinc-400 hover:text-gold transition-colors">
        <MapPin size={13} className="text-gold" /> {open ? a.hide : `${a.showAll} (${list.length})`}
        <ChevronDown size={13} className={`transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-5">
          <div className="relative max-w-xs">
            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" aria-hidden />
            <input data-testid="footer-cities-search" aria-label={a.search} value={q} onChange={(e) => setQ(e.target.value)} placeholder={a.search}
              className="w-full bg-black border border-white/15 pl-9 pr-3 py-2.5 text-[14px] text-white placeholder:text-zinc-600 focus:outline-none focus:border-gold" />
          </div>
          <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2" aria-label={a.footerTitle}>
            {list.map((e) => (
              <li key={e.label}>
                <button type="button" data-testid={`footer-city-${e.label}`} onClick={() => pick(e.label)}
                  className={`text-[14px] transition-colors hover:text-gold ${e.area === "extended" ? "text-zinc-500" : "text-zinc-300"}`}>
                  {e.label}{e.area === "extended" ? " *" : ""}
                </button>
              </li>
            ))}
          </ul>
          <p className="mt-4 text-[12px] text-zinc-500">* {p22Copy(lang).booking.location.extendedNote}</p>
        </div>
      )}
    </div>
  );
};
